import { render, staticRenderFns } from "./TeamCreateStaffInfo.vue?vue&type=template&id=b6764cea&"
import script from "./TeamCreateStaffInfo.vue?vue&type=script&lang=ts&"
export * from "./TeamCreateStaffInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports